import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { AppUtils } from 'src/app/helpers/app.utils';
import { PageUrls } from 'src/app/helpers/page-urls';
import { AlbumService } from 'src/app/services/album.service';
import { AlbumModel } from 'src/app/models/album.model';
import { SubcategoryEditModel } from 'src/app/admin/models/subcategory.edit.model';

@Component({
    selector: 'app-subcategory-edit',
    templateUrl: './subcategory.edit.component.html'
})

export class SubcategoryEditComponent implements OnInit {
    imageCategories = new Array<AlbumModel>();
    model = new SubcategoryEditModel();

    constructor(private router: Router,
        private route: ActivatedRoute,
        private ngxSpinner: NgxSpinnerService,
        private toastr: ToastrService,
        private albumService: AlbumService) { }

    get urls() {
        return PageUrls;
    }

    ngOnInit() {
        this.model.id = this.route.snapshot.queryParams.subcategoryId;
        this.loadCategories();
        this.getSubcategory();
    }

    getSubcategory() {
        this.ngxSpinner.show();
        this.albumService.getSubcategory(this.model.id).subscribe(
            data => {
                this.ngxSpinner.hide();
                Object.assign(this.model, data);
            },
            error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    loadCategories() {
        this.ngxSpinner.show();
        this.albumService.getAlbumList().subscribe(
            (categories) => {
                this.ngxSpinner.hide();
                this.imageCategories = categories;
            },
            error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    submit() {
        this.ngxSpinner.show();
        this.albumService.editSubCategory(this.model).subscribe(
            (data) => {
                this.ngxSpinner.hide();
                this.router.navigateByUrl(`${PageUrls.Admin.SubcategoryManage}`);
                setTimeout(() => {
                    this.toastr.success('Subcategory has been updated successfully');
                });
            },
            error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }
}


